import { useMedplum } from '@medplum/react';
import { Patient } from '@medplum/fhirtypes';
import { IDENTIFIERS } from '@consts/systems.consts';

export const useMedplumSearch = () => {
  const medplum = useMedplum();

  /**
   * Find a patient by AMKA identifier
   *
   * @param amka - The 11-digit AMKA number
   * @returns The patient if found, null otherwise
   */
  const findPersonByAmka = async (amka: string): Promise<Patient | null> => {
    const result = await medplum.searchResources('Patient', {
      identifier: `${IDENTIFIERS.AMKA}|${amka}`,
    });
    return result?.[0] ?? null;
  };

  return {
    findPersonByAmka,
  };
};
